import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const ScrollBoxStyle = styled.div`
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: ${props => (
        props.$scrollbarVisible
            ? "2px 8px 2px 2px"
            : "2px 2px 2px 2px"
    )};
    transition: padding 90ms ease;

    &::-webkit-scrollbar {
        width: 3px;
        height: 3px;
        margin-left: 5px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const ScrollBox = props => {

    const { ref, children } = props;

    const scrollBoxRef = useRef(null);
    const [scrollbarVisible, setScrollbarVisible] = useState(false);

    useEffect(() => {
        const contentWrapper = scrollBoxRef.current;
        if (!contentWrapper) {
            return undefined;
        };
        const updateScrollState = () => {
            setScrollbarVisible(contentWrapper.scrollHeight > contentWrapper.clientHeight);
        };
        updateScrollState();

        const mutationObserver = new MutationObserver(updateScrollState);
        mutationObserver.observe(contentWrapper, {
            attributes: true,
            childList: true,
            subtree: true,
        });
        const resizeObserver = new ResizeObserver(updateScrollState);
        resizeObserver.observe(contentWrapper);
        return () => {
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        if (ref) {
            ref.current = scrollBoxRef.current;
        }
    }, [ref]);

    return (
        <ScrollBoxStyle
            ref={scrollBoxRef}
            $scrollbarVisible={scrollbarVisible}>
            {children}
        </ScrollBoxStyle>
    );
};